import React from "react";

const EmployeeAppContainer = (props) => {
  return <div className="employee-app-container">{props.children}</div>;
};

export default EmployeeAppContainer;
